import React from 'react';
import { FormattedMessage } from 'react-intl';

import { COLOR, FONT_SIZES, FONT_FAMILIES } from 'config';
import Button from 'components/Button';

const containerStyle = {
  fontFamily: FONT_FAMILIES.sans,
  fontSize: `${FONT_SIZES[2]}px`,
  lineHeight: '1.5',
  position: 'fixed',
  bottom: '0px',
  display: 'flex',
  flexDirection: 'column',
  width: '100%',
  zIndex: 1000,
};

const alertStyle = {
  background: '#1b3150e6',
  padding: '20px 30px',
  color: COLOR.white,
  maxWidth: '800px',
  alignSelf: 'center',
};

const titleStyle = {
  fontSize: `${FONT_SIZES[6]}px`,
  fontFamily: FONT_FAMILIES.sansBold,
  marginBottom: '5px',
};

const buttonStyle = {
  marginTop: '15px',
  display: 'block',
};

const linkStyle = {
  color: COLOR.white,
};

const hideStyle = {
  display: 'none',
};

const cookiesStorageKey = 'cookiesAccepted';

class CookiesAlert extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      hide: window.localStorage.getItem(cookiesStorageKey),
    };

    this.accept = this.accept.bind(this);
  }

  accept() {
    window.localStorage.setItem(cookiesStorageKey, 'true');
    this.setState({ hide: true });
  }

  render() {
    return (
      <div style={this.state.hide ? hideStyle : containerStyle}>
        <div style={alertStyle}>
          <div>
            <div style={titleStyle}><FormattedMessage id="cookiesAlert.title" /></div>
            <div>
              <FormattedMessage id="cookiesAlert.content1" />&nbsp;
              <a href="/legal" style={linkStyle}><FormattedMessage id="cookiesAlert.content2" /></a>
            </div>
          </div>
          <Button
            style={buttonStyle}
            color={COLOR.white}
            bg={COLOR.base}
            onClick={this.accept}
            pill
          >
            <FormattedMessage id="cookiesAlert.button" />
          </Button>
        </div>
      </div>
    );
  }
}

export default CookiesAlert;



// WEBPACK FOOTER //
// ./src/components/App/components/CookiesAlert/CookiesAlert.js